import { TextField } from "@mui/material";
import { useState } from "react";
import { ErrorText } from "./ErrorText";
import { FieldErrorList } from "../types";
import {
    createLocalMomentFromUTC,
    createUtcMoment,
    parseDateStringForMoment,
    parseTimeStringForMoment,
} from "../tools";

type DateTimeFieldProps = {
    disabled: boolean;
    value: string;
    setValue: (value: string) => void;
    errors?: FieldErrorList;
    required?: boolean;
};

export const DateTimeField = (props: DateTimeFieldProps) => {
    const { disabled, value, setValue, errors = [], required = false } = props;

    const [dateTimeUTC, setDateTimeUtc] = useState(createUtcMoment(value));

    return (
        <div>
            <TextField
                type="date"
                size="small"
                error={errors.length > 0}
                disabled={disabled}
                InputLabelProps={{
                    shrink: true,
                }}
                value={createLocalMomentFromUTC(dateTimeUTC).format("YYYY-MM-DD")}
                onChange={(e) => {
                    const date = createLocalMomentFromUTC(dateTimeUTC);
                    date.set(parseDateStringForMoment(e.target.value));
                    setDateTimeUtc(date.utc());
                    setValue(date.utc().toISOString());
                }}
                required={required}
            />
            <TextField
                type="time"
                size="small"
                error={errors.length > 0}
                disabled={disabled}
                InputLabelProps={{
                    shrink: true,
                }}
                value={createLocalMomentFromUTC(dateTimeUTC).format("HH:mm")}
                onChange={(e) => {
                    const date = createLocalMomentFromUTC(dateTimeUTC);
                    date.set(parseTimeStringForMoment(e.target.value));
                    setDateTimeUtc(date.utc());
                    setValue(date.utc().toISOString());
                }}
                required={required}
            />
            <ErrorText data={errors} />
        </div>
    );
};
